var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeebox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 224 224",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.992
    },
    fill: "#060606",
    d: "M -0.5,-0.5 C 74.1667,-0.5 148.833,-0.5 223.5,-0.5C 223.5,74.1667 223.5,148.833 223.5,223.5C 148.833,223.5 74.1667,223.5 -0.5,223.5C -0.5,148.833 -0.5,74.1667 -0.5,-0.5 Z M 11.5,12.5 C 78.1667,12.5 144.833,12.5 211.5,12.5C 211.5,78.8333 211.5,145.167 211.5,211.5C 144.833,211.5 78.1667,211.5 11.5,211.5C 11.5,145.167 11.5,78.8333 11.5,12.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.996
    },
    fill: "#202020",
    d: "M 59.5,34.5 C 62.2254,35.713 64.5588,37.5464 66.5,40C 55,51.5 43.5,63 32,74.5C 31.0975,73.2986 29.9308,72.4652 28.5,72C 26.9926,71.1627 26.4926,69.9961 27,68.5C 38.0372,57.2977 48.8705,45.9643 59.5,34.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.996
    },
    fill: "#1d1d1d",
    d: "M 163.5,34.5 C 175.416,45.2483 186.916,56.5816 198,68.5C 198.507,69.9961 198.007,71.1627 196.5,72C 195.069,72.4652 193.903,73.2986 193,74.5C 181.5,63 170,51.5 158.5,40C 160.373,38.2962 162.04,36.4628 163.5,34.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.996
    },
    fill: "#141414",
    d: "M 68.5,47.5 C 69.8999,48.0998 70.8999,49.0998 71.5,50.5C 72.6389,59.7494 75.4722,68.4161 80,76.5C 89.6508,86.9847 99.4841,97.318 109.5,107.5C 106.683,110.818 103.683,113.985 100.5,117C 99.5,117.667 98.5,117.667 97.5,117C 87.8039,106.97 77.8039,97.303 67.5,88C 57.7265,82.9632 47.3931,79.9632 36.5,79C 47.0349,68.2979 57.7016,57.7979 68.5,47.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.996
    },
    fill: "#818180",
    d: "M 71.5,50.5 C 70.8999,49.0998 69.8999,48.0998 68.5,47.5C 68.811,46.5222 69.4777,45.8555 70.5,45.5C 71.4519,47.0453 71.7852,48.712 71.5,50.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.996
    },
    fill: "#131313",
    d: "M 153.5,45.5 C 165.08,55.5765 176.247,66.2432 187,77.5C 187.483,78.448 187.649,79.448 187.5,80.5C 174.902,79.9817 163.568,83.4817 153.5,91C 124.5,120 95.5,149 66.5,178C 60.168,182.172 53.5013,185.672 46.5,188.5C 46.1667,187.833 45.8333,187.167 45.5,186.5C 48.7338,179.268 52.4005,172.268 56.5,165.5C 86.5143,136.319 116.014,106.652 145,76.5C 150.424,66.8798 153.258,56.5465 153.5,45.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.996
    },
    fill: "#151515",
    d: "M 169.5,168.5 C 169.427,170.027 170.094,171.027 171.5,171.5C 174.086,175.671 176.42,180.004 178.5,184.5C 178.5,185.833 177.833,186.5 176.5,186.5C 169.5,183.674 162.833,180.174 156.5,176C 142.986,162.653 129.653,149.153 116.5,135.5C 119.833,131.5 123.5,127.833 127.5,124.5C 142.328,138.655 156.328,153.321 169.5,168.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.996
    },
    fill: "#949494",
    d: "M 169.5,168.5 C 170.906,168.973 171.573,169.973 171.5,171.5C 170.094,171.027 169.427,170.027 169.5,168.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.996
    },
    fill: "#a4a4a4",
    d: "M 178.5,184.5 C 179.404,185.209 179.737,186.209 179.5,187.5C 178.209,187.737 177.209,187.404 176.5,186.5C 177.833,186.5 178.5,185.833 178.5,184.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeebox);
export default __webpack_public_path__ + "static/media/teebox.5cbf3a90c0c36273c73ece33aa54ed98.svg";
export { ForwardRef as ReactComponent };